var AddressGiftFormView = (function (_baseView, _fieldView, _getPageTemplate) {

    var giftAddressRoot = 'checkout.address.gift.form';
    var giftMessageRoot = 'checkout.address.gift.message.form';
    var giftAddressMessageRoot = 'checkout.address.gift.address.message.form';

    var formModes = {
        giftAddress: 1,
        giftMessage: 2,
        giftAddressMessage: 3
    }

    var _progressClassName = 'processing-animation';



    var GiftDateView = Backbone.View.extend({
        el: '@GiftDateEdit',

        initialize: function () {
            _.bindAll(this, '_render', '_changed', '_update');
            this._render();
            this.model.on('change:GiftDate', this._update);
            this._update();
        },

        _render: function() {
            this.dateSelector = app.GiftDateSelector(this.$el, false);
            this.dateSelector.init();
            this.dateSelector.onChange(_.bind(function (_isValid, sd, d) {
                this._changed(d.day, d.month, d.year);
            }, this));
        },

        _update: function () {
            var d = this.model.get('GiftDate');
            if (d) {
                this.date = {
                    day: d.getDate(),
                    month: d.getMonth() + 1,
                    year: d.getFullYear()
                }
                this.dateSelector.setDate(this.date);
            }
        },

        _changed: function(day, month, year) {
            this.date = {
                day: day,
                month: month,
                year: year
            }
        },

        setValue: function (date) {
            var d = this.date || {};
            if (date && !d.day && !d.month && !d.year) {
                this.date = {
                    day: date.getDate(),
                    month: date.getMonth() + 1,
                    year: date.getFullYear()
                }
                this.dateSelector.setDate(this.date);
            }
        },

        getValue: function() {
            if (this.date) {
                var d = this.date;
                if (d.day && d.month && d.year) {
                    return new Date(d.year, d.month - 1, d.day);
                }
            }
            return null;
        }
    });

    var GiftOccasionView = Backbone.View.extend({
        el: '#GiftOccasion',

        events: {
            'change': '_changed'
        },

        initialize: function () {
            _.bindAll(this, '_render', '_update', '_changed');
            this._settings = CheckoutSettings.getBasketSettings();
            this._render();
            this.model.on('change:GiftOccasion', this._update);
        },

        _render: function() {
            this.$el.append($('<option value></option>'));
            _.each(this._settings.GiftOccasions, _.bind(function (occasion) {
                var option = $('<option value="' + occasion.Key + '" data-date="' + occasion.Value + '">' + occasion.Key + '</option>');
                if (occasion.Key === this.model.get('GiftOccasion')) {
                    option.attr('selected', true);
                }
                this.$el.append(option);
            }, this));
        },

        _changed: function(e) {
            if (!e) return;
            var el = $(e.currentTarget);
            var option = el.find('option:selected');

            var value = el.val();
            var dateValue = option.data('date');

            this.model.set('GiftOccasionEdit', value || null);

            if (dateValue) {
                dateValue = dateValue.replace(/(\d\d)\/(\d\d)\/(\d\d\d\d)/, '$2/$1/$3');
                var tic = Date.parse(dateValue) || null;
                if (tic) {
                    var d = new Date(tic);
                    this.trigger('occasionChanged', d);
                }
            }
        },

        onChanged: function(cb) {
            this.on('occasionChanged', cb);
        },

        _update: function(m) {
            this.$el.find('option:selected').prop("selected", false);
            this.$el.find('option[value=' + m.get('GiftOccasion') + ']').prop("selected", true);
        }
    });

    var GiftMessageView = Backbone.View.extend({
        el: '#GiftMessage',

        initialize: function () {
            _.bindAll(this, '_update');
            this._settings = CheckoutSettings.getBasketSettings();
            this.model.on('change:GiftMessage', this._update);
        },

        _update: function(m) {
            this.$el.val(m.get('GiftMessage'));
        }
    });

    return _baseView.extend({
        el: '@newGiftAddress',

        displayRoutes: [giftAddressRoot, giftMessageRoot, giftAddressMessageRoot],

        events: {
            'click @btnSaveDetails': '_saveDetails'
        },

        initialize: function () {
            _.bindAll(this, '_toggleDeliveryType', '_saveDetails', '_saveMessage', '_saveAddress', '_inProgress');

            this._settings = CheckoutSettings.getBasketSettings();

            this.$fields = this.$('@fields');
            this.$title = this.$('@title');
            this.$occasions = this.$('@occasions');
            this.$giftMessage = this.$('#GiftMessage');
            this.$giftOccasion = this.$('#GiftOccasion');
            this.$giftDate = this.$('#GiftDate');

            InitTooltip(this.$occasions.find('@infoMessage'), 'GiftInfoMessageField');
            InitTooltip(this.$occasions.find('@infoOccasion'), 'GiftInfoOccasionField');
            InitTooltip(this.$occasions.find('@infoDate'), 'GiftInfoDateField');

            this._giftAddressFields = this.model.giftForm();
            this._giftMessageModel = this.model.currentGiftMessage();

            this.render();
            this.listenTo(this._giftAddressFields, 'add', _.bind(this._renderField, this));
            this.listenTo(this._giftAddressFields, 'deliveryTypeChange', this._toggleDeliveryType);

        },

        render: function () {
            new GiftMessageView({ model: this._giftMessageModel });
            this._giftAddressFields.each(_.bind(this._renderField, this));
            this._giftOccasion = new GiftOccasionView({ model: this._giftMessageModel });
            this._giftDate = new GiftDateView({ model: this._giftMessageModel });

            this._giftOccasion.onChanged(_.bind(function(date) {
                this._giftDate.setValue(date);
            }, this));
        },

        _saveDetails: function(e) {
            e.preventDefault();
            var _currentState = this.getCurrentState();
            var xhr;

            this._inProgress(true);

            if (_currentState === giftAddressRoot) {
                xhr = this._saveAddress().fail(_.bind(this._failed, this));
            } else if (_currentState === giftMessageRoot) {
                xhr = this._saveMessage();
            } else {
                if (!this._giftAddressFields.isValid()) {
                    this._inProgress(false);
                    this._failed();
                } else {
                    var $deff = new $.Deferred();
                    var address = this._saveAddress()
                        .fail(_.bind(function() {
                                this._failed();
                        }, this));

                    var message = this._saveMessage();

                    $.when(address, message).done($deff.resolve);

                    xhr = $deff.promise();
                }
            }

            xhr && xhr
                .done(_.bind(this._saved, this))
                .always(_.bind(function () {
                    this._inProgress(false);
                }, this));
        },

        _saveAddress: function () {
            window.app && app.event && app.event.useThisAddress();
            
            return this._giftAddressFields.save();
        },

        _saveMessage: function () {
            var message = this.$giftMessage.val();
            var occasion = this.$giftOccasion.val();
            var date = this._giftDate.getValue();
            return this._giftMessageModel.save(message, occasion, date);
        },

        beforeShow: function (data) {
            var _currentState = this.getCurrentState();

            if (_currentState === giftAddressRoot) {
                this._currentFormMode = formModes.giftAddress;
            } else if (_currentState === giftMessageRoot) {
                this._currentFormMode = formModes.giftMessage;
            } else {
                this._currentFormMode = formModes.giftAddressMessage;
            }

            this.$fields.toggleClass('hidden-block', this._currentFormMode === formModes.giftMessage);
            this.$title.toggleClass('hidden-block', this._currentFormMode === formModes.giftMessage);
            this.$occasions.toggleClass('hidden-block', this._currentFormMode === formModes.giftAddress);

            this._backTo = data ? data.backTo : null;
            this._onSavedCallback = data ? data.callback : null;
        },

        _renderField: function (model) {
            var field = new _fieldView({ model: model });
            this.$fields.append(field.$el);
        },

        _saved: function () {
            if (this._onSavedCallback) {
                this._onSavedCallback();
            } else {
                this.display(this._backTo || 'checkout');
            }
        },

        _failed: function () {
            alert(_getPageTemplate('_FillAllFields'));
        },

        _toggleDeliveryType: function (type) {
            //this.type = type;
            this.$('@signature').toggleClass('hidden-block', type !== CheckoutSettings.addressDeliveryTypes.signature);
            this.$('@pickup').toggleClass('hidden-block', type !== CheckoutSettings.addressDeliveryTypes.pickup);
            this._giftAddressFields.each(function (model) {
                var name = model.get('Name') || '';
                var isHidden = !(type !== CheckoutSettings.addressDeliveryTypes.pickup || name.match(/^(Name|Phone)$/i));
                model.setHidden(isHidden);
            });
        },

        _inProgress: function(inProgress) {
            this.$('@btnSaveDetails').toggleClass(_progressClassName, inProgress);
        }
    });
})(BaseView, FieldView, kos.getPageTemplate, GlobalSettings);